/* ==========================================================================
   PartizoPro theme.js — interactions
   ========================================================================== */
(function () {
  "use strict";

  var PartizoPro = window.PartizoPro || {};
  PartizoPro.currency = PartizoPro.currency || {};
  PartizoPro.money_format = PartizoPro.money_format || "${{amount}}";

  window.Parts = PartizoPro;

  /* ------------------------------------------------------------------
     Money format
  ------------------------------------------------------------------ */
  PartizoPro.formatMoney = function (cents, format) {
    var f = format || PartizoPro.money_format;
    var value = (cents || 0) / 100;
    var thousandsSep = ",";
    var decimalSep = ".";
    var fmt = f;

    if (fmt.indexOf("{{amount}}") === -1) {
      return f;
    }

    var noCents = fmt.indexOf("{{amount_no_decimals}}") !== -1;
    var withCents = fmt.indexOf("{{amount_with_decimals}}") !== -1;

    function withCommas(num) {
      var parts = num.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
      return parts.join(decimalSep);
    }

    var out;
    if (noCents) {
      out = withCommas(Math.round(value));
      fmt = fmt.replace("{{amount}}", out);
    } else {
      out = withCommas(value.toFixed(2));
      fmt = fmt.replace("{{amount}}", out);
    }
    if (withCents) {
      fmt = fmt.replace("{{amount_no_decimals}}", out);
    }
    return fmt;
  };

  /* ------------------------------------------------------------------
     Toast
  ------------------------------------------------------------------ */
  function toastEl() {
    var t = document.querySelector("[data-toast]");
    if (!t) {
      t = document.createElement("div");
      t.className = "toast";
      t.setAttribute("data-toast", "");
      t.setAttribute("role", "status");
      document.body.appendChild(t);
    }
    return t;
  }

  PartizoPro.toast = function (message, isError) {
    var t = toastEl();
    t.textContent = message;
    t.classList.toggle("toast--err", !!isError);
    t.classList.add("is-visible");
    clearTimeout(t._timer);
    t._timer = setTimeout(function () {
      t.classList.remove("is-visible");
    }, 3200);
  };

  /* ------------------------------------------------------------------
     Drawers (mobile menu / cart)
  ------------------------------------------------------------------ */
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add("drawer--open");
    document.body.style.overflow = "hidden";
    d.setAttribute("aria-hidden", "false");
  }

  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove("drawer--open");
    document.body.style.overflow = "";
    d.setAttribute("aria-hidden", "true");
  }

  PartizoPro.openDrawer = openDrawer;
  PartizoPro.closeDrawer = closeDrawer;

  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-drawer-open]");
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute("data-drawer-open"));
      return;
    }

    var closer = e.target.closest("[data-drawer-close]");
    if (closer) {
      e.preventDefault();
      var panel = closer.closest(".drawer");
      closeDrawer(panel);
      return;
    }

    if (e.target.classList.contains("drawer__overlay")) {
      closeDrawer(e.target.closest(".drawer"));
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      document.querySelectorAll(".drawer--open").forEach(closeDrawer);
    }
  });

  /* ------------------------------------------------------------------
     Category tree toggles
  ------------------------------------------------------------------ */
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest(".cat-tree__toggle");
    if (!toggle) return;
    var group = toggle.closest(".cat-tree__group");
    if (!group) return;
    var sub = group.querySelector(".cat-tree__sub");
    if (!sub) return;
    var open = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", String(!open));
    sub.classList.toggle("is-open", !open);
  });

  /* ------------------------------------------------------------------
     Hero slider
  ------------------------------------------------------------------ */
  function initHero(root) {
    var track = root.querySelector(".hero__track");
    var slides = root.querySelectorAll(".hero__slide");
    var dots = root.querySelectorAll(".hero__dot");
    if (!track || slides.length === 0) return;

    var index = 0;
    var timer = null;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = "translateX(-" + index * 100 + "%)";
      dots.forEach(function (d, di) {
        d.classList.toggle("is-active", di === index);
        d.setAttribute("aria-selected", di === index ? "true" : "false");
      });
    }

    function start() {
      if (slides.length < 2) return;
      stop();
      timer = setInterval(function () {
        go(index + 1);
      }, 6000);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    var prev = root.querySelector("[data-hero-prev]");
    var next = root.querySelector("[data-hero-next]");

    if (prev) prev.addEventListener("click", function () { go(index - 1); start(); });
    if (next) next.addEventListener("click", function () { go(index + 1); start(); });

    dots.forEach(function (d, di) {
      d.addEventListener("click", function () { go(di); start(); });
    });

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);

    /* Touch swipe */
    var startX = null;
    root.addEventListener("touchstart", function (e) {
      startX = e.touches[0].clientX;
      stop();
    }, { passive: true });
    root.addEventListener("touchend", function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 45) go(index + (dx < 0 ? 1 : -1));
      startX = null;
      start();
    });

    go(0);
    start();
  }

  /* ------------------------------------------------------------------
     Quantity steppers
  ------------------------------------------------------------------ */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".qty__btn");
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest(".qty");
    var input = wrap.querySelector(".qty__input");
    if (!input) return;
    var step = parseInt(input.getAttribute("data-step") || "1", 10);
    var min = parseInt(input.getAttribute("min") || "1", 10);
    var max = parseInt(input.getAttribute("max") || "9999", 10);
    var val = parseInt(input.value || "1", 10);
    if (btn.classList.contains("qty__btn--up")) {
      val = Math.min(max, val + step);
    } else {
      val = Math.max(min, val - step);
    }
    input.value = val;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ------------------------------------------------------------------
     Tabs
  ------------------------------------------------------------------ */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-tab]");
    if (!btn) return;
    var group = btn.closest("[data-tabs]");
    if (!group) return;
    var key = btn.getAttribute("data-tab");
    group.querySelectorAll("[data-tab]").forEach(function (b) {
      b.classList.toggle("is-active", b === btn);
    });
    group.querySelectorAll("[data-tab-panel]").forEach(function (p) {
      p.classList.toggle("is-active", p.getAttribute("data-tab-panel") === key);
    });
  });

  /* ------------------------------------------------------------------
     FAQ accordion
  ------------------------------------------------------------------ */
  document.addEventListener("click", function (e) {
    var q = e.target.closest(".faq__q");
    if (!q) return;
    var answer = q.nextElementSibling;
    if (!answer) return;
    var open = q.getAttribute("aria-expanded") === "true";
    q.setAttribute("aria-expanded", String(!open));
    answer.style.maxHeight = open ? "0px" : answer.scrollHeight + 24 + "px";
  });

  /* ------------------------------------------------------------------
     Add to cart (AJAX)
  ------------------------------------------------------------------ */
  var routes = window.PartizoPro && window.PartizoPro.routes ? window.PartizoPro.routes : {};

  function updateCartCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? "" : "none";
    });
  }

  function refreshCartDrawer() {
    if (!routes.cart || !routes.cartDrawer) return;
    fetch(routes.cart, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var count = data.item_count || 0;
        updateCartCount(count);
        return fetch(routes.cartDrawer + "?section_id=" + (window.PartizoPro.cartDrawerSection || "cart-drawer"))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var holder = document.getElementById("CartDrawer");
            if (!holder) return;
            var body = holder.querySelector(".drawer__body");
            if (body) body.innerHTML = html;
          });
      })
      .catch(function () { /* silent */ });
  }

  PartizoPro.refreshCartDrawer = refreshCartDrawer;

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.matches("[data-product-form]")) return;
    e.preventDefault();

    var btn = form.querySelector("[type=submit]");
    if (btn) {
      btn.disabled = true;
      btn.setAttribute("aria-busy", "true");
    }

    var fd = new FormData(form);
    fetch("/cart/add.js", {
      method: "POST",
      body: fd,
      headers: { Accept: "application/javascript" }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status === 200 || data.status === 201) {
          PartizoPro.toast(data.description || "已加入购物车");
          updateCartCount(data.item_count || 0);
          refreshCartDrawer();
          if (form.hasAttribute("data-open-cart")) {
            openDrawer("CartDrawer");
          }
        } else {
          PartizoPro.toast(data.description || "加入购物车失败", true);
        }
      })
      .catch(function () {
        PartizoPro.toast("网络错误，请重试", true);
      })
      .then(function () {
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute("aria-busy");
        }
      });
  });

  /* ------------------------------------------------------------------
     Wishlist (localStorage, demo-level)
  ------------------------------------------------------------------ */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-wish]");
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute("data-wish");
    var key = "pp_wishlist";
    var list = [];
    try {
      list = JSON.parse(localStorage.getItem(key) || "[]");
    } catch (err) {
      list = [];
    }
    var i = list.indexOf(id);
    if (i === -1) {
      list.push(id);
      btn.classList.add("is-active");
      PartizoPro.toast("已加入收藏");
    } else {
      list.splice(i, 1);
      btn.classList.remove("is-active");
      PartizoPro.toast("已取消收藏");
    }
    try {
      localStorage.setItem(key, JSON.stringify(list));
    } catch (err) { /* ignore */ }
  });

  /* ------------------------------------------------------------------
     Gallery thumbnails
  ------------------------------------------------------------------ */
  document.addEventListener("click", function (e) {
    var thumb = e.target.closest(".product__thumb");
    if (!thumb) return;
    var wrap = thumb.closest(".product__gallery");
    if (!wrap) return;
    var main = wrap.querySelector(".product__main-img img");
    var src = thumb.getAttribute("data-src");
    if (main && src) main.src = src;
    wrap.querySelectorAll(".product__thumb").forEach(function (t) {
      t.classList.toggle("is-active", t === thumb);
    });
  });

  /* ------------------------------------------------------------------
     Faceted search / filter auto-submit
  ------------------------------------------------------------------ */
  document.addEventListener("change", function (e) {
    var input = e.target.closest("[data-filter-auto]");
    if (!input) return;
    var form = input.closest("form");
    if (form) form.submit();
  });

  /* ------------------------------------------------------------------
     Sort dropdown
  ------------------------------------------------------------------ */
  document.addEventListener("change", function (e) {
    var sel = e.target.closest("[data-sort]");
    if (!sel || !sel.value) return;
    var url = new URL(window.location.href);
    url.searchParams.set("sort_by", sel.value);
    window.location.href = url.toString();
  });

  /* ------------------------------------------------------------------
     Init
  ------------------------------------------------------------------ */
  function init() {
    document.querySelectorAll("[data-hero]").forEach(initHero);

    /* Init FAQ open state */
    document.querySelectorAll('.faq__q[aria-expanded="true"]').forEach(function (q) {
      var a = q.nextElementSibling;
      if (a) a.style.maxHeight = a.scrollHeight + "px";
    });

    /* Init active wishlist buttons */
    try {
      var list = JSON.parse(localStorage.getItem("pp_wishlist") || "[]");
      list.forEach(function (id) {
        var btn = document.querySelector('[data-wish="' + id + '"]');
        if (btn) btn.classList.add("is-active");
      });
    } catch (err) { /* ignore */ }

    /* Re-init sliders on section load (Shopify editor) */
    document.addEventListener("shopify:section:load", function (e) {
      var section = e.target;
      if (section.querySelector("[data-hero]")) {
        initHero(section.querySelector("[data-hero]"));
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
